module.exports = __webpack_public_path__ + "static/media/title_15.37943868.svg";